import React, { useState } from "react";
import { Modal, Button, Box, Typography, Card } from "@mui/material"; // v5;
import CareContext from "../hlthtek-demo/components/CareContext";
import CareContextForModal from "./CareContextForModal";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CareContextNonAbdmModal from "./CareContextNonAbdmModal";
import CareContextNonAbdmFlow from "./CareContextNonAbdmFlow";
import CareContextCreationNonAbdm from "../hlthtek-demo/components/CareContextCreationNonAbdm";
import { StyledModal } from "../doctor-console/StyledComponents";
const CareContextModal = ({ isOpen, handleClose, abhaId, patId }) => {
  console.log("this is it", abhaId);
  console.log("this is it patId", patId);
  return (
  
    <StyledModal
      open={isOpen}
      handleClose={handleClose}
      title="Create Visit Purpose"
    >
      {abhaId ? (
        <CareContextCreationNonAbdm abhaId={abhaId} handleClose={handleClose} />
      ) : (
        <CareContextNonAbdmModal patId={patId} handleClose={handleClose} />
      )}
    </StyledModal>
  );
};
export default CareContextModal;
